import { Disclosure, Transition } from "@headlessui/react";
import React from "react";
import type { HTMLComponent } from "@commercekit/react";
import WvArrow from "./WvArrow";

const WvDisclosure: HTMLComponent<{
  disclosureTitle: string | JSX.Element;
  defaultOpen?: boolean;
  as?: React.ElementType;
}> = ({
  disclosureTitle,
  children,
  defaultOpen = false,
  as = "div",
  ...props
}) => {
  return (
    <Disclosure defaultOpen={defaultOpen} {...props}>
      {({ open }) => (
        <>
          <Disclosure.Button
            as={as}
            className="flex justify-between items-center w-full"
          >
            {disclosureTitle}
            <WvArrow
              direction={open ? "t" : "b"}
              className="transition-transform duration-300"
              size="sm"
            />
          </Disclosure.Button>
          <Transition
            enter="transition-all ease-in-out duration-300"
            enterFrom="max-h-0 overflow-y-hidden"
            enterTo="max-h-screen overflow-y-hidden"
            leave="transition-all ease-in-out duration-300"
            leaveFrom="max-h-screen overflow-y-hidden"
            leaveTo="max-h-0 overflow-y-hidden"
          >
            <Disclosure.Panel>{children}</Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
};

export default WvDisclosure;
